<sdc-bo-dialog
  headerTitle="Are you sure you want to delete this AdLink?"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'adlink-delete-modal-' + data?.id">
  <div class="content-wrapper">
    @if (data?.urlImage) {
      <div class="image-preview">
        <img [src]="data.urlImage" alt="" />
      </div>
    }
    <sdc-info-grid
      [items]="[
        { label: 'Name', value: data?.name },
        { label: 'Title', value: data?.title },
        { label: 'Link', value: data?.link },
        { label: 'Visibility', value: data?.active ? 'On' : 'Off' },
      ]"
      [columns]="2" />
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      variant="secondary"
      [attr.data-cy]="'adlink-delete-modal-cancel-button-' + data?.id"
      (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      variant="destructive"
      [attr.data-cy]="'adlink-delete-modal-confirm-button-' + data?.id"
      (onClick)="onConfirm(data?.id)">
      Permanently delete
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
